export function getIsMobileOptimized(state) {
  return state.template.mobileOptimized;
}

export function getIsEditable(state) {
  return state.template.editable;
}

export function getTemplateId(state) {
  return state.template.id;
}

export function getTemplateName(state) {
  return state.template.name;
}

export function getTemplateCSSUrl(state) {
  return state.template.cssUrl;
}
